<template>
  <v-card class="fluid-column ma-5">


    <div>
      <v-card-item>
        <v-card-title class="text-headline-small">Log trasferimenti</v-card-title>
        <v-card-subtitle class="">I dati trasferiti durante la sessione corrente 
      </v-card-subtitle>
      </v-card-item>

      <v-card-item>
        <v-card-title class="text-title-large text-grey-darken-2 pl-3">Ultimo</v-card-title>
      </v-card-item>
      <v-card-text class="">
        <p v-html="transferStore?.lastSuccessfulRun?.log.replaceAll('\n', '<br>')"></p>
      </v-card-text>

      <v-card-item>
        <v-card-title class="text-title-large text-grey-darken-2 pl-3">Avvenuti con successo</v-card-title>
      </v-card-item>
      <v-card-text class="">
        <p v-for="run of transferStore.successfulRuns">
          <strong >
            {{  run?.date?.toLocaleTimeString() }}
          </strong>
          {{  run?.log.replaceAll('\n', '<br>') }}
        </p>
      </v-card-text>
    </div>


  </v-card>
</template>

<script setup>

import { onMounted, ref, computed } from "vue";


import { useTransferStore } from "@/store/transfer"
const transferStore = useTransferStore()


// const projExtent = getProjection('EPSG:32632')?.getExtent();




onMounted(() => {



});


</script>

<style scoped>
.pulsating {
  animation-name: color;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate-reverse;
  animation-timing-function: linear;
}


@keyframes color {
  from {
    color: orange;
  }

  to {
    color: white;
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px orange;
  }
}

.no-mouse {
  pointer-events: none;
}
</style>
